<script setup lang="ts">
/********************
 * COMPOSITIONS      *
 ********************/
const localePath = useLocalePath();
const regionService = useRegionService();
const route = useRoute();
const { dynamicHeadline } = useDynamicHeadline();
const { fetchError } = useFetchError();
const { locale } = useI18n();

/********************
 * INITIALIZATION    *
 ********************/
const { data, error } = await useAsyncData(route.fullPath, async () => {
  try {
    const response = await regionService.getPopularRegions(locale.value);
    const links = response.map(item => ({
      label: item.name,
      route: localePath({ name: RBN_REGION_SEARCH, params: { regionSlug: item.slug } }),
      slug: item.slug,
    }));
    return {
      links,
    };
  } catch (error) {
    fetchError(error);
    return error;
  }
});

if (error.value) {
  throw createError({ statusCode: error.value?.statusCode, message: error.value.statusMessage });
}
</script>

<template>
  <div class="link-list col-12 col-md-8 offset-md-2 py-6 md:py-12">
    <div class="container">
      <h1
        v-if="dynamicHeadline"
        class="mb-12 text-center"
      >
        {{ dynamicHeadline }}
      </h1>
      <CiLinkList :links="data?.links" />
    </div>
  </div>
</template>
